/**
 * @function invoiceStageDisplay
 * @description To fetch the Stage name of the given input
 * @param {String} stageHuman - Stage name
 * @returns {String} Human-readable stage name
 * @author Jatin Hariani
 * @date 2018/XX/XX
 */
export function invoiceStageDisplay(stageHuman) {
  const maps = {
    'Exporter E-Sign Pending': 'Esign Required',
    'Exporter E-Sign Generated': 'Esign Required',
    'Invoice Processing': 'Processing'
  }
  return maps[stageHuman] ? maps[stageHuman] : stageHuman
}

/**
 * @function invoiceStageClass
 * @description To fetch the class for the relative stage name
 * @param {String} stageHuman - Stage name
 * @returns {String} css class name
 * @author Jatin Hariani
 * @date 2018/XX/XX
 */
export function invoiceStageClass(stageHuman) {
  const maps = {
    'Exporter E-Sign Pending': 'text-danger',
    'Exporter E-Sign Generated': 'text-danger',
    'Exporter Docs Pending': 'text-danger'
  }
  return maps[stageHuman] ? maps[stageHuman] : ''
}

/**
 * @function percentSign
 * @description To Convert into percent number
 * @param {Number} number - The number to convert
 * @returns {String} Percentile number
 * @author Jatin Hariani
 * @date 2018/XX/XX
 */
export function percentSign(number) {
  try {
    return parseFloat(number) + '%'
  } catch (e) {
    return 'N/A'
  }
}

/**
 * @function capitalize
 * @description To capitalize the inputted text
 * @param {String} str - The text to capitalize
 * @returns {String} Capitalize text
 * @author Jatin Hariani
 * @date 2018/XX/XX
 */
export function capitalize(str) {
  if (str) {
    return str.replace(/^\w/, (c) => c.toUpperCase())
  }
  return ''
}
